import { useMutation } from "@apollo/react-hooks";

import saveInstructorBusinessProfile from "../graph-ql/saveInstructorBusinessProfile.graphql";

const useMutationSaveInstructorBusinessProfile = () =>
  useMutation(saveInstructorBusinessProfile);

export default useMutationSaveInstructorBusinessProfile;
